import axios from "../../../../../../api/axiosInstance";
import {
  FetchProductStoreProductsRequest,
  FetchProductStoreProductsResponse,
} from "./types";

export const fetchProductStoreProducts = async (
  params: FetchProductStoreProductsRequest,
  signal?: AbortSignal,
): Promise<FetchProductStoreProductsResponse> => {
  const response = await axios.get<FetchProductStoreProductsResponse>(
    "/api/private/product-store/products",
    { params, signal },
  );
  return response.data;
};
